import axios from '@/service/request';

// 登录
export const login = (url, params) => axios.post(`/login/${url}`, params);

// 注册
export const register = (url, params) => axios.post(`/register/${url}`, params);

// 退出登录
export const logout = params => axios.post('/login/logout', params);

// 验证码获取
export const getVerificationCode = (url, params) => axios.post(`/code/${url}`, params);

// 图形验证码获取
export const getCode = params => axios.get('/code/getCode', { params: { ...params } });

// 重置密码
export const resetPassword = params => axios.post('/login/reset_password', params);

//  游客注册登录
export const deviceAccountLoginRegister = params => axios.post('/register/device_account', params);
